import React from 'react';
import { Global, css } from '@emotion/react';
import { TAG_COLORS } from '../types';

export const tagColorCssVar = (c: string) => `--crm-tag-color-${c}`;

const tagColors = css`
  :root {
    ${TAG_COLORS.map(c => `${tagColorCssVar(c.value)}: ${c.color};`).join("\n")}
    ${tagColorCssVar("fallback")}: #E0E0E0;
  }
`;

export const CRMStyles = () => {
  return (
    <>
      <Global styles={tagColors} />
    </>
  );
}